const RankingQueryKey = {
  RANKING: 'RANKING',
};

export default RankingQueryKey;
